module.exports = __webpack_public_path__ + "static/media/Escaleras.2ac76463.jpg";